import React from 'react';

const Contact = () => {
    return (
        <section id="contact" className="contact-section">
            <h2>Contact</h2>
            <div className="contact-card">
                <p className="contact-text">If you would like to get in touch, feel free to reach out.</p>
                <a className="contact-email" href="mailto:sriram.yerramsetty1@gmail.com">
                    sriram.yerramsetty1@gmail.com
                </a>
            </div>
        </section>
    );
};

export default Contact;